import './App.css';
import AppHeader from './components/common/appHeader/AppHeader';
import { Box } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import Routes from './Routes';

function App() {
  return (
    <AuthProvider>
        <Box>
          <AppHeader/>
          <Routes />
        </Box>
      </AuthProvider>
    );
}

export default App;
